import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../global/commonStyle';

const MainContent = styled.div`
  position: sticky;
  top: 0;
  z-index: var(--z-index-99);
  width: 100%;
`;

const Content = styled.div`
  ${FlexBetween}
  padding: var(--space-14) var(--space-24);
  background-color: var(--background-secondary);
  margin-block: var(--space-0) var(--space-4);
  border-bottom: 0.5px solid var(--border-primary);
  gap: var(--space-24);
`;

const Left = styled.div`
  ${AlignCenter}
  gap: var(--space-20);
`;
const ProjectName = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
`;

const Buttons = styled.div`
  display: flex;
  gap: var(--space-5);
  ${mobile_xl(css`
    padding: var(--space-8) var(--space-20);
    margin-bottom: var(--space-8);
  `)}
`;

const Right = styled.div`
  display: flex;
  gap: var(--space-12);
`;

const ProjectTitle = styled.h1`
  ${Typography.heading_lg}
  color: var(--text-primary);
  margin: var(--space-0);
`;

export { MainContent, Content, Left, ProjectName, Buttons, Right, ProjectTitle };
